export enum PayPalIntent {
  CAPTURE = "capture",
  AUTHORIZE = "authorize",
}
